/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // allow users to use the search feature while the mobile menu is open

  document.addEventListener('DOMContentLoaded', function() {


    // button
    const hamburgerButton = document.querySelector('.header__mobile__hamburger');
    // "menu/CLOSE" small html element inside of button
    const navText = document.querySelector('.header__mobile__hamburger .navtext');
    // parent
    const drawerHeader = document.querySelector('.drawer--header');
    // header element to remove the border bottom when the menu is open
    const header = document.querySelector('.theme__header.has-border');
 
 
    if (navText && hamburgerButton && drawerHeader) {
       
        // if the drawer is open, change the small html element text
        function updateButtonText() {
            const isExpanded = hamburgerButton.getAttribute('aria-expanded') === 'true';
            const drawerHeaderIsOpen = document.querySelector('.drawer--header.is-open');
           
            navText.textContent = isExpanded && drawerHeaderIsOpen ? theme.strings.close : theme.strings.menu;

            // If the drawer is open, remove the border bottom from the header
            if (isExpanded && drawerHeaderIsOpen) {
              if (header) header.classList.add('remove__border');
          } else {
              // Add a small delay so the border doesnt come back too abrupt
              setTimeout(() => {
                  if (header) header.classList.remove('remove__border');
              }, 200);
          }
        }
       
        // the drawer gets added the class "is-open" when it is open
        // so we can listen to it.
        // this fixes the issue of only listening to the button click but
        // the user opens the cart while the mobile menu is open,
        // keeping the button text as "CLOSE" instead of "Menu".
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    updateButtonText();
                }
            });
        });
       
        // Start observing the drawer for class changes
        observer.observe(drawerHeader, { attributes: true });
       
        // Also watch for aria-expanded changes on the hamburger button
        const buttonObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'aria-expanded') {
                    updateButtonText();
                }
            });
        });
       
        buttonObserver.observe(hamburgerButton, { attributes: true });
    }
 });

 // modifies the price in the add to cart button when the variant changes


 
function initPriceUpdate() {
  // Check if we're on a product page and have product data
  if (!window.product || !document.querySelector('[data-single-option-selector]')) {
    return; // Exit early if we are not on a product page
  }
  
  document.addEventListener('change', function(e) {
    
    // Check if the changed element is a variant selector
    if (e.target.matches('[data-single-option-selector]')) {
      
      const optionInputs = document.querySelectorAll('[data-single-option-selector]');
      
      const selectedOptions = [];
      optionInputs.forEach(input => {
        if (input.type === 'radio' && input.checked) {
          selectedOptions.push(input.value);
        } else if (input.type === 'hidden') {
          selectedOptions.push(input.value);
        }
      });
            
      // Find matching variant
      const selectedVariant = window.product.variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
            
      // Update price if the variant is found
      if (selectedVariant) {
        const priceElement = document.querySelector('[data-price]');
        
        if (priceElement) {
          const price = selectedVariant.price / 100;
          const currency = window.Shopify?.currency?.active;
          
          // Keep KR for Danish currency, use proper formatting for others
          if (currency === 'DKK') {
            const formattedPrice = price.toFixed(2).replace('.', ',') + ' DKK';
            priceElement.textContent = formattedPrice;
          } 
          if (currency === 'SEK') {
            const formattedPrice = price.toFixed(2).replace('.', ',') + ' SEK';
            priceElement.textContent = formattedPrice;
          } 
          else {
            const formattedPrice = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: currency
            }).format(price);
            priceElement.textContent = formattedPrice;
          }
          
        }
      }
    }
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initPriceUpdate);
 

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

  function animatedBtnText() {
    const btnContainers = document.querySelectorAll('.animated-btn');
    const btnValues = document.querySelectorAll('.animated-btn-value');
    let currentIndex = 0;

    if(btnContainers.length === 0) return;
    if(btnValues.length === 0) return;
  
    btnContainers.forEach((container) => {
      const btnValues = container.querySelectorAll('.animated-btn-value');
      let currentIndex = 0;
  
      if (btnValues.length > 0) {
        btnValues[currentIndex].classList.add('visible');
      }
  
      setInterval(() => {
        btnValues[currentIndex].classList.remove('visible');
        currentIndex = (currentIndex + 1) % btnValues.length;
        btnValues[currentIndex].classList.add('visible');
      }, 3000); 
    });
  }
  
  animatedBtnText();

  async function loadAllProducts() {
    const templateSuffix = "json-bb";
    const collectionHandle = "masterlist";
    const urlPrefix = window.theme.routes.root;

    // if (urlPrefix !== "/") urlPrefix += "/";

    const response = await fetch(
      `${urlPrefix}collections/${collectionHandle}?view=${templateSuffix}`,
      {
        type: "GET",
      }
    );

    const json = await response.json();
    window.ALL_PRODUCTS = json.products;
  }

  loadAllProducts();

  function setStickyPdpButton() {
    const buttonFromMobile = document.querySelector('.product__content-mobile .atc-button');
    const buttonFromRegimen = document.querySelector('.regimen-form__content .atc-button');
    const originalButton = buttonFromMobile ?? buttonFromRegimen;
    if (!originalButton) return;

    const buttonRect = originalButton.getBoundingClientRect();
    const buttonHeight = buttonRect.height;
    const buttonWidth = buttonRect.width;

    if (buttonHeight === 0 || buttonWidth === 0) return;

    // Clone the button and create a fixed version of it which is exactly the same height and length as the original button, in the same xy, cooditions

    const clonedButton = originalButton.cloneNode(true);
    clonedButton.classList.add('cloned-button');
    clonedButton.style.position = 'fixed';
    // clonedButton.style.top = '20px';
    clonedButton.style.left = `${buttonRect.left}px`;
    clonedButton.style.zIndex = '1000';
    clonedButton.style.visibility = 'hidden';
    clonedButton.style.opacity = '0';

    document.body.appendChild(clonedButton);

    window.addEventListener('scroll', () => {
      const header = document.querySelector('.theme__header');
      const headerWrapper = document.querySelector('.header__wrapper.js__header__stuck');
      const headerHeight = (headerWrapper && header) ? header.getBoundingClientRect().height : 0;
      const buttonTopThreshold = 20 + headerHeight;


      const buttonRect = originalButton.getBoundingClientRect();
      const buttonTop = buttonRect.top;
      let isWithinViewport = true;  // Default to true for mobile button

      if (buttonFromRegimen) {
        const shopifySection = buttonFromRegimen.closest('.shopify-section');
        if (shopifySection) {
          const sectionRect = shopifySection.getBoundingClientRect();
          const sectionTop = sectionRect.top;
          const sectionBottom = sectionRect.bottom - 150; // Subtract 150px from section bottom
          const viewportHeight = window.innerHeight;

          if (sectionTop < viewportHeight && sectionBottom > 0) {
              isWithinViewport = true;
          } else {
              isWithinViewport = false;
          }
        }
      }

      if (buttonTop <= buttonTopThreshold && isWithinViewport) {
        // Hide the original button and show the cloned button
        clonedButton.style.visibility = 'visible';
        clonedButton.style.opacity = '1';
        clonedButton.style.width = `${buttonWidth}px`;
        clonedButton.style.height = `${buttonHeight}px`;
        clonedButton.style.top = `${buttonTopThreshold}px`;

        originalButton.style.visibility = 'hidden';
        originalButton.style.opacity = '0';
      } else {
        clonedButton.style.visibility = 'hidden';
        clonedButton.style.opacity = '0';
        clonedButton.style.width = '0';
        clonedButton.style.height = '0';

        originalButton.style.visibility = 'visible';
        originalButton.style.opacity = '1';
      }
    });
  }

  setStickyPdpButton();

  // Fix: Thumbnail scroll patch
  // The scroll handler in ProductThumbs incorrectly marks all thumbs as is-active
  // when the product image container fills the viewport, which blocks click events.
  // This fix corrects the is-active state after each scroll so only the active slide's
  // thumb is marked as is-active.
  (function() {
    function applyThumbScrollFix() {
      var productThumbs = document.querySelector('product-thumbs');
      if (!productThumbs) return;

      var section = productThumbs.closest('[data-section-type="product"]');
      if (!section) return;

      var productImagesContainer = section.querySelector('[data-product-media-list]');
      if (!productImagesContainer) return;

      window.addEventListener('scroll', function() {
        var activeSlide = productImagesContainer.querySelector('.product__slide.media--active');
        if (!activeSlide) return;

        var activeMediaId = activeSlide.getAttribute('data-media-id');
        if (!activeMediaId) return;

        var thumbItems = productThumbs.querySelectorAll('[data-thumb-item]');
        thumbItems.forEach(function(item) {
          var link = item.querySelector('[data-thumb-link]');
          if (!link) return;
          if (link.getAttribute('data-media-id') === activeMediaId) {
            item.classList.add('is-active');
          } else {
            item.classList.remove('is-active');
          }
        });
      }, false);
    }

    document.addEventListener('DOMContentLoaded', function() {
      applyThumbScrollFix();
      setTimeout(applyThumbScrollFix, 1000);
    });
  })();

})();

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function updateLeftArrowVisibility() {
  const dropdownPanel = document.querySelector('.mobile__menu__dropdown.sliderule__panel.is-visible');
  const leftSymbol = document.querySelector('.left_symbol');
  if (dropdownPanel && leftSymbol) {
      leftSymbol.classList.add('is-visible');
  } else {
      const leftSymbolVisible = document.querySelector('.left_symbol.is-visible');
      if (leftSymbolVisible) {
          leftSymbolVisible.classList.remove('is-visible');
      }
  }
};

setInterval(updateLeftArrowVisibility, 10);



if (window.location.pathname === '/cart') {
  sessionStorage.setItem('redirectFromCart', 'true');
  window.location.href = '/';
}

if (window.location.pathname === '/') {
  const fromCart = sessionStorage.getItem('redirectFromCart');

  if (fromCart === 'true') {
    const cartBodyContent = document.querySelector('.drawer__body-content.drawer__body-cart');
    if (cartBodyContent) {
      cartBodyContent.classList.add('is-visible');
    }

    const cartFootContent = document.querySelector('.drawer__foot.drawer__foot-cart');
    if (cartFootContent) {
      cartFootContent.classList.add('is-visible');
    }

    const menuContent = document.querySelector('.drawer__body-content.drawer__body-menu.original-visible.is-visible');
    if (menuContent) {
      menuContent.classList.remove('is-visible');
    }

    sessionStorage.removeItem('redirectFromCart');
  }
}

// Run the script on all quiz pages
const quizPaths = ['/pages/quiz', '/pages/hudkonsultation', '/pages/skinconsultation', '/pages/hudanalys'];
if (quizPaths.includes(window.location.pathname)) {
  // Using WeakSet so each button is processed only once
  const processedButtons = new WeakSet();

  function attachQuizListeners(container) {
    const quizButtons = container.querySelectorAll('[data-variant-id]');
    quizButtons.forEach((button) => {
      if (!processedButtons.has(button)) {
        processedButtons.add(button);

        button.addEventListener('click', () => {
          setTimeout(() => {
            document.dispatchEvent(new Event('theme:cart:refresh'));
            document.dispatchEvent(new Event('theme:cart:toggle'));
          }, 600);
        });
      }
    });

    // Match "Add All" button by text content across all markets (DK/SE/COM)
    // This is more robust than CSS class matching which can change on Quiz Kit updates
    const addAllKeywords = ['TILFØJ ALLE', 'LÄGG TILL ALLA', 'ADD ALL'];
    const allButtons = container.querySelectorAll('button');
    allButtons.forEach((btn) => {
      const text = btn.textContent.trim().toUpperCase();
      if (addAllKeywords.some(kw => text.includes(kw)) && !processedButtons.has(btn)) {
        processedButtons.add(btn);
        btn.addEventListener('click', () => {
          setTimeout(() => {
            document.dispatchEvent(new Event('theme:cart:refresh'));
            document.dispatchEvent(new Event('theme:cart:toggle'));
          }, 600);
        });
      }
    });
  }

  attachQuizListeners(document.body);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            attachQuizListeners(node);
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fix: Force Quiz Kit to load all product images on results page without any visible scroll jump.
  // Quiz Kit lazy-loads images using IntersectionObserver on .quiz-kit-image-container--loading divs.
  // Images below the fold stay unloaded until scrolled into view.
  // This fix creates a temporary off-screen scrollable container that mirrors the unloaded image
  // positions, triggering their IntersectionObserver without moving the actual page.
  let lazyLoadTriggered = false;

  function triggerQuizKitImageLoad() {
    if (lazyLoadTriggered) return;
    const loadingImgs = Array.from(document.querySelectorAll('.quiz-kit-image-container--loading'));
    if (loadingImgs.length === 0) return;
    lazyLoadTriggered = true;

    // Use a new IntersectionObserver with rootMargin covering the full page height
    // This forces Quiz Kit's own observer to see all elements as intersecting
    // by temporarily making the document taller via a ghost element, then
    // dispatching a resize event which causes Quiz Kit to re-evaluate intersections.
    //
    // Approach: temporarily expand viewport awareness by adding a large rootMargin
    // observer that scrolls each unloaded element into a hidden off-screen div.
    const ghost = document.createElement('div');
    ghost.style.cssText = 'position:fixed;top:0;left:-9999px;width:1px;overflow-y:scroll;height:100vh;visibility:hidden;pointer-events:none;';
    document.body.appendChild(ghost);

    // Clone each unloaded container into the ghost scroller at the same relative position
    // so Quiz Kit's IntersectionObserver (which observes document root) fires for them
    // Instead - simpler approach: dispatch a scroll event on window which re-triggers
    // IntersectionObserver callbacks, combined with temporarily setting rootMargin
    ghost.remove();

    // Simplest reliable approach: use scrollTo with instant behavior to bottom then back
    // but lock the scroll position visually using CSS overflow:hidden on body
    const scrollPos = window.scrollY;
    document.documentElement.style.scrollBehavior = 'auto';

    // Lock body scroll position visually
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPos}px`;
    document.body.style.width = '100%';

    // Now scroll the document (user won't see it because body is fixed)
    window.scrollTo(0, document.body.scrollHeight);

    requestAnimationFrame(() => {
      window.scrollTo(0, scrollPos);
      requestAnimationFrame(() => {
        // Restore body
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.documentElement.style.scrollBehavior = '';
        window.scrollTo(0, scrollPos);
        lazyLoadTriggered = false;
      });
    });
  }

  const lazyLoadObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (
              (node.className && typeof node.className === 'string' && node.className.includes('quiz-kit-image-container--loading')) ||
              (node.querySelector && node.querySelector('.quiz-kit-image-container--loading'))
            ) {
              setTimeout(triggerQuizKitImageLoad, 300);
            }
          }
        });
      }
    });
  });

  lazyLoadObserver.observe(document.body, { childList: true, subtree: true });

  // Style "TILFØJ ALLE TIL KURVEN" / "ADD ALL TO CART" / "LÄGG TILL ALLA" as a prominent CTA button
  const addAllCTAStyle = document.createElement('style');
  addAllCTAStyle.textContent = `
    /* Quiz Kit - Add All to Cart CTA styling */
    #quiz-kit-content button.quiz-kit-add-all-cta {
      display: block !important;
      width: 100% !important;
      max-width: 480px !important;
      margin: 8px auto 32px auto !important;
      padding: 18px 32px !important;
      background-color: #1a1a1a !important;
      color: #ffffff !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      letter-spacing: 0.12em !important;
      text-transform: uppercase !important;
      border: none !important;
      border-radius: 0 !important;
      cursor: pointer !important;
      transition: background-color 0.2s ease !important;
    }
    #quiz-kit-content button.quiz-kit-add-all-cta:hover {
      background-color: #333333 !important;
    }
  `;
  document.head.appendChild(addAllCTAStyle);

  const addAllKeywordsList = ['TILF\u00d8J ALLE', 'L\u00c4GG TILL ALLA', 'ADD ALL'];

  function styleAddAllButtons() {
    const allBtns = document.querySelectorAll('#quiz-kit-content button');
    allBtns.forEach(btn => {
      const text = btn.textContent.trim().toUpperCase();
      if (addAllKeywordsList.some(kw => text.includes(kw))) {
        btn.classList.add('quiz-kit-add-all-cta');
      }
    });
  }

  const addAllStyleObserver = new MutationObserver(() => styleAddAllButtons());
  addAllStyleObserver.observe(document.body, { childList: true, subtree: true });
  styleAddAllButtons();

}

// Style variant swatches as clean rectangular text buttons instead of image thumbnails
(function() {
  const swatchStyle = document.createElement('style');
  swatchStyle.textContent = `
    /* Scope all swatch overrides to product page only via body.template-product */
    body.template-product .product__page radio-swatch .image-wrapper,
    body.template-product .product__page radio-swatch img,
    body.template-product .product__page radio-swatch figure {
      display: none !important;
    }

    body.template-product .product__page radio-swatch {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: auto !important;
      height: auto !important;
      min-width: 64px !important;
      padding: 9px 16px !important;
      border: 1.5px solid #ccc !important;
      background: transparent !important;
      cursor: pointer !important;
      position: relative !important;
    }

    /* Selected state: filled black */
    body.template-product .product__page radio-swatch:has(.sibling__link--current) {
      border-color: #1a1a1a !important;
      border-width: 2px !important;
      background: #1a1a1a !important;
    }

    body.template-product .product__page radio-swatch:has(.sibling__link--current)::after {
      color: #fff !important;
      font-weight: 600 !important;
    }

    /* Show the tooltip text as the button label */
    body.template-product .product__page radio-swatch::after {
      content: attr(data-tooltip) !important;
      font-family: Saans, Figtree, sans-serif !important;
      font-size: 12px !important;
      font-weight: 500 !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase !important;
      color: #888 !important;
      white-space: nowrap !important;
    }

    /* Hide floating tooltip that overlaps buy button */
    body.template-product .tooltip-default {
      display: none !important;
    }

    /* Hide the original tooltip popup */
    body.template-product .product__page radio-swatch .swatch__tooltip {
      display: none !important;
    }

    /* Make anchor an invisible full-cover overlay so clicks navigate correctly */
    body.template-product .product__page radio-swatch a.sibling__link {
      position: absolute !important;
      inset: 0 !important;
      z-index: 2 !important;
      opacity: 0 !important;
      display: block !important;
    }
  `;
  document.head.appendChild(swatchStyle);

  // Rename 'Travel Size' / 'Rejsestørrelse' / 'Resestorlek' to '10 ml' in swatch tooltips
  function renameTravelSize() {
    document.querySelectorAll('radio-swatch').forEach(function(swatch) {
      const tooltip = (swatch.getAttribute('data-tooltip') || '').toLowerCase();
      if (tooltip.includes('travel') || tooltip.includes('rejse') || tooltip.includes('rese')) {
        swatch.setAttribute('data-tooltip', '10 ml');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renameTravelSize);
  } else {
    renameTravelSize();
  }
})();

document.addEventListener('DOMContentLoaded', function() {
  const countrySelectors = document.querySelectorAll('.popout-list__option');

  countrySelectors.forEach(selector => {
    selector.addEventListener('click', function() {
      const countryCode = this.getAttribute('data-country-code');
      const countryLanguage = this.getAttribute('data-country-language');
      updateLocalization({country: countryCode, language: countryLanguage.toLowerCase().slice(0, 2)});
    });
  });
});

function updateLocalization({country, language}) {
  if (country === 'UK') {
    country = 'GB';
  }

  if (country === 'EU') {
    console.log('EU country detected, setting to DE');
    country = 'DE';
  }

  // 10 specific Outside Europe countries
  const outsideEuropeCountries = ['AU', 'CA', 'FO', 'IS', 'MC', 'NO', 'CH', 'TR', 'GB', 'US'];
  if (outsideEuropeCountries.includes(country)) {
    console.log('Outside Europe market country detected:', country);
    country = 'US';
  }

  const formId = crypto.randomUUID();
  const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${country}">
      <input name="language_code" value="${language}">
    </form>
  `;
  document.body.insertAdjacentHTML("beforeend", formHtml);
  document.getElementById(formId).submit();
}

// Inject #no-thank-you anchor on philosophy pages where it is missing (DK and SE)
// COM already has the anchor natively; DK and SE do not
// Since custom.js is deferred, the browser tries to scroll to #no-thank-you before
// the anchor exists. We inject it and then manually scroll to it if the hash matches.
(function() {
  if (!window.location.pathname.includes('/pages/philosophy')) return;

  function injectAndScroll() {
    if (document.getElementById('no-thank-you')) {
      // Anchor already exists (COM) - if hash matches, scroll to it
      if (window.location.hash === '#no-thank-you') {
        const el = document.getElementById('no-thank-you');
        const headerHeight = document.querySelector('.theme__header')?.offsetHeight || 80;
        const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top, behavior: 'smooth' });
      }
      return;
    }

    // Find the No list heading
    // DK: "Det er et 'nej' fra os"
    // SE: "Det är ett nej från oss."
    const headings = document.querySelectorAll('h1, h2, h3');
    for (const heading of headings) {
      const text = heading.textContent.trim().toLowerCase();
      if (text.includes('fra os') || text.includes('från oss')) {
        const anchor = document.createElement('a');
        anchor.id = 'no-thank-you';
        anchor.style.display = 'block';
        anchor.style.visibility = 'hidden';
        heading.parentElement.insertBefore(anchor, heading);

        // If the page was loaded with #no-thank-you hash, scroll to it now
        if (window.location.hash === '#no-thank-you') {
          setTimeout(function() {
            const headerHeight = document.querySelector('.theme__header')?.offsetHeight || 80;
            const top = anchor.getBoundingClientRect().top + window.scrollY - headerHeight;
            window.scrollTo({ top, behavior: 'smooth' });
          }, 100);
        }
        break;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectAndScroll);
  } else {
    injectAndScroll();
  }
})();

/* ---------------------------------------------------------------------------
   Cookie bar (Consentmo GDPR) — Jorgobé styling
   ---------------------------------------------------------------------------
   The app renders its banner inside an OPEN shadow root on the custom element
   <csm-cookie-consent>, so nothing in theme.css / dev.css can reach it. These
   rules are injected into that shadow root instead.

   Paste this block at the bottom of assets/custom.js (already loaded on every
   page — no theme.liquid change needed).

   Stable hooks used (verified against the app bundle, not guessed):
     .cc-window                        banner root
     #cookieconsent-desc               the consent paragraph
     #isense-cc-cookie-bar-text        the long text itself
     [data-csm-button-type="accept"]   Accept
     [data-csm-button-type="reject"]   Reject
     [data-csm-button-type="preferences"]  Preferences
     .cc-settings-dialog             the preferences dialog
     .cc-settings-dialog .cc-btn     its footer buttons (these carry NO
                                     data-csm-button-type, only cc-allow /
                                     cc-deny / cc-settings / cc-btn-accept-selected)
   The app sets --csm-button-border-radius and the button colours as INLINE
   custom properties, which is why every override below carries !important.
--------------------------------------------------------------------------- */

(function () {
  var CSS = [
    /* Long consent text + privacy link — Lector italic */
    '#cookieconsent-desc,',
    '#cookieconsent-desc #isense-cc-cookie-bar-text,',
    '#cookieconsent-desc .cc-link {',
    '  font-family: "Lector", Cardo, serif !important;',
    '  font-style: italic !important;',
    '  font-weight: 400 !important;',
    '  line-height: 1.5 !important;',
    '}',

    /* Buttons — square, uppercase Saans with brand kerning */
    '.cc-window [data-csm-button-type] {',
    '  --csm-button-border-radius: 0px !important;',
    '  border-radius: 0 !important;',
    '  font-family: "Saans", Figtree, sans-serif !important;',
    '  font-weight: 500 !important;',
    '  font-size: 12px !important;',
    '  letter-spacing: 0.05em !important;',
    '  text-transform: uppercase !important;',
    '  min-height: 44px !important;',
    '  padding: 10px 22px !important;',
    '  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease !important;',
    '}',

    /* Accept — solid black */
    '.cc-window [data-csm-button-type="accept"] {',
    '  background-color: #151515 !important;',
    '  border: 1px solid #151515 !important;',
    '  color: #FFFFFF !important;',
    '}',
    '.cc-window [data-csm-button-type="accept"]:hover {',
    '  background-color: #2E2E2E !important;',
    '  border-color: #2E2E2E !important;',
    '  color: #FFFFFF !important;',
    '}',

    /* Reject + Preferences — outline */
    '.cc-window [data-csm-button-type="reject"],',
    '.cc-window [data-csm-button-type="preferences"] {',
    '  background-color: transparent !important;',
    '  border: 1px solid #151515 !important;',
    '  color: #151515 !important;',
    '}',
    '.cc-window [data-csm-button-type="reject"]:hover,',
    '.cc-window [data-csm-button-type="preferences"]:hover {',
    '  background-color: #151515 !important;',
    '  border-color: #151515 !important;',
    '  color: #FFFFFF !important;',
    '}',

    /* ---------- Preferences dialog ---------- */

    /* Panel — square corners */
    '.cc-settings-dialog {',
    '  border-radius: 0 !important;',
    '}',

    /* Heading — Lector */
    '.cc-settings-dialog .cookie-settings-header,',
    '.cc-settings-dialog .isense-cookie-settings-header {',
    '  font-family: "Lector", Cardo, serif !important;',
    '  font-weight: 400 !important;',
    '  font-style: normal !important;',
    '  letter-spacing: 0 !important;',
    '}',

    /* Consent copy — Lector. The intro line stays italic (same voice as the
       bar); the category descriptions are roman so the body copy reads easily.
       padding-inline-end stops the text column clear of the toggle
       (44px switch + 12px gap). */
    '.cc-settings-dialog .isense-cookie_settings_description,',
    '.cc-settings-dialog .cc-cookie-category-text,',
    '.cc-settings-dialog .isense-cc-cookie-category-text,',
    '.cc-settings-dialog .csm-gcm-footer {',
    '  font-family: "Lector", Cardo, serif !important;',
    '  font-weight: 400 !important;',
    '  line-height: 1.5 !important;',
    '  padding-inline-end: 56px !important;',
    '}',
    '.cc-settings-dialog .isense-cookie_settings_description,',
    '.cc-settings-dialog .csm-gcm-footer {',
    '  font-style: italic !important;',
    '}',
    '.cc-settings-dialog .cc-cookie-category-text,',
    '.cc-settings-dialog .isense-cc-cookie-category-text {',
    '  font-style: normal !important;',
    '}',

    /* Category names — Saans label treatment */
    '.cc-settings-dialog [class*="isense-cc-prefence-title-"] {',
    '  font-family: "Saans", Figtree, sans-serif !important;',
    '  font-style: normal !important;',
    '  font-weight: 500 !important;',
    '  font-size: 13px !important;',
    '  letter-spacing: 0.05em !important;',
    '  text-transform: uppercase !important;',
    '}',

    /* No rule lines — whitespace separates (brand rule) */
    '.cc-settings-dialog hr {',
    '  display: none !important;',
    '}',
    '.cc-settings-dialog .csm-dpp-section {',
    '  gap: 4px !important;',
    '  padding-top: 22px !important;',
    '  padding-bottom: 22px !important;',
    '}',

    /* Links in the Google footer — ink, not browser blue */
    '.cc-settings-dialog .csm-gcm-footer a {',
    '  color: #151515 !important;',
    '  text-decoration: underline !important;',
    '}',

    /* Footer buttons — square, uppercase Saans */
    '.cc-settings-dialog .cc-btn:not(.cc-btn-close-settings) {',
    '  --csm-button-border-radius: 0px !important;',
    '  border-radius: 0 !important;',
    '  font-family: "Saans", Figtree, sans-serif !important;',
    '  font-weight: 500 !important;',
    '  font-size: 12px !important;',
    '  letter-spacing: 0.05em !important;',
    '  text-transform: uppercase !important;',
    '  min-height: 44px !important;',
    '  padding: 10px 22px !important;',
    '  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease !important;',
    '}',

    /* Accept all — solid black (the one primary, as on the bar) */
    '.cc-settings-dialog .cc-btn.cc-allow:not(.cc-btn-accept-selected) {',
    '  background-color: #151515 !important;',
    '  border: 1px solid #151515 !important;',
    '  color: #FFFFFF !important;',
    '}',
    '.cc-settings-dialog .cc-btn.cc-allow:not(.cc-btn-accept-selected):hover {',
    '  background-color: #2E2E2E !important;',
    '  border-color: #2E2E2E !important;',
    '  color: #FFFFFF !important;',
    '}',

    /* Save selection + Reject all — outline */
    '.cc-settings-dialog .cc-btn.cc-btn-accept-selected,',
    '.cc-settings-dialog .cc-btn.cc-settings,',
    '.cc-settings-dialog .cc-btn.cc-deny {',
    '  background-color: transparent !important;',
    '  border: 1px solid #151515 !important;',
    '  color: #151515 !important;',
    '}',
    '.cc-settings-dialog .cc-btn.cc-btn-accept-selected:hover,',
    '.cc-settings-dialog .cc-btn.cc-settings:hover,',
    '.cc-settings-dialog .cc-btn.cc-deny:hover {',
    '  background-color: #151515 !important;',
    '  border-color: #151515 !important;',
    '  color: #FFFFFF !important;',
    '}'
  ].join('\n');

  var STYLE_ID = 'jorgobe-cookie-bar-style';

  function inject() {
    var host = document.querySelector('csm-cookie-consent');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById(STYLE_ID)) return true;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    host.shadowRoot.appendChild(style);
    return true;
  }

  /* The host element and its shadow root are created asynchronously by the
     app, and shadow-tree mutations don't reach a light-DOM observer — so poll
     briefly until it exists, then stop. */
  if (inject()) return;
  var tries = 0;
  var timer = setInterval(function () {
    if (inject() || ++tries > 200) clearInterval(timer);
  }, 150);
})();

/* ---------------------------------------------------------------------------
   Quiz Kit results page: send "See your full regimen" to the recommended
   regimen, not to /collections/regimens, and print prices like the rest of
   the site.
   ---------------------------------------------------------------------------
   Quiz Kit renders the results in normal DOM inside #quiz-kit-content (no
   shadow root, no iframe). The hero block at the bottom has one static link,
   set in the Quiz Kit editor, that goes to the regimen collection. This block
   reads the result heading ("Hud med fine linjer & rynker.", "Fine Lines &
   Wrinkles" etc.), matches it to a regimen handle and rewrites that link.
   Works on DK, COM and SE, because the match is on keywords in all three
   languages. The handles are the same in all three markets.
   The same block also rewrites the product prices into the site's own money
   format (see below).
   Quiz Kit re-renders on its own, so a MutationObserver re-applies both
   whenever the results DOM changes.
--------------------------------------------------------------------------- */
(function () {
  var quizPages = ['/pages/quiz', '/pages/hudkonsultation', '/pages/skinconsultation', '/pages/hudanalys'];
  if (!quizPages.includes(window.location.pathname)) return;

  var REGIMENS = [
    [/pigment/i, 'pigmentation-regimen'],
    [/fine lin|fina lin/i, 'fine-lines-wrinkles-regimen'],
    [/porer|pores/i, 'pores-blackheads'],
    [/balance|balanserad/i, 'balanced-skin-regimen'],
    [/rødme|redness|rodnad/i, 'redness-irritation'],
    [/tørhed|dryness|torrhet/i, 'dryness-dehydration'],
    [/olieret|oily|fet hud/i, 'oily-skin-regimen'],
    [/urenheder|blemishes|oren/i, 'blemishes-regimen'],
    [/glød|mat hud|matt hud|dullness/i, 'dullness-regimen']
  ];

  function rootPath() {
    var r = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    return r.endsWith('/') ? r : r + '/';
  }

  function applyRegimenLink() {
    var content = document.getElementById('quiz-kit-content');
    if (!content) return;

    var links = content.querySelectorAll('a[href*="/collections/regimens"], a[data-regimen-link]');
    if (!links.length) return;

    var headings = content.querySelectorAll('h1, h2');
    var match = null;
    for (var i = 0; i < headings.length && !match; i++) {
      var text = headings[i].textContent.trim();
      for (var j = 0; j < REGIMENS.length; j++) {
        if (REGIMENS[j][0].test(text)) { match = REGIMENS[j][1]; break; }
      }
    }
    if (!match) return;

    var url = rootPath() + 'products/' + match;
    links.forEach(function (a) {
      if (a.getAttribute('href') !== url) a.setAttribute('href', url);
      a.setAttribute('data-regimen-link', match);
    });
  }

  /* Prices: Quiz Kit prints "kr250,00" while the rest of the site prints
     "250,00 DKK" (the shop's money-with-currency format). Each price element
     carries data-price="250.0", so the text is rebuilt from that number in the
     site's format, with the active market currency (DKK, SEK, EUR). */
  function formatAmount(n) {
    var parts = n.toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  function applyPriceFormat() {
    var content = document.getElementById('quiz-kit-content');
    if (!content) return;
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!currency) return;

    content.querySelectorAll('[data-price]').forEach(function (el) {
      var n = parseFloat(el.getAttribute('data-price'));
      if (isNaN(n)) return;
      var target = el;
      while (target.children.length === 1) target = target.children[0];
      if (!/\d/.test(target.textContent)) return;
      var text = formatAmount(n) + ' ' + currency;
      if (target.textContent !== text) target.textContent = text;
    });
  }

  function apply() {
    applyRegimenLink();
    applyPriceFormat();
  }

  var pending = null;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; apply(); }, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

  apply();
})();
